import React, { useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ClearIcon from "@mui/icons-material/Clear";

import { subTypes } from "../itemTypes";
import OptionIcon from "./OptionIcon";
import InputField from "../Components/InputField";

export default function Option({
  option,
  type,
  index,
  selectedId,
  handleChange,
  removeOption,
  handleAddOptionAfterIndex,
  disabled,
  allowOptionAdd,
}) {
  const { t } = useTranslation();
  const [isMouseOver, setIsMouseOver] = useState(false);
  const isOptionDisabled = [
    subTypes.yesno,
    subTypes.multiSmiley,
    subTypes.bodyParts,
  ].includes(type);

  const mouseOver = () => {
    setIsMouseOver(true);
  };

  const mouseOut = () => {
    setIsMouseOver(false);
  };

  return (
    <Draggable
      draggableId={"Option" + option.id}
      index={index}
      isDragDisabled={isOptionDisabled || disabled}
    >
      {(provided) => (
        <Box
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onMouseOver={mouseOver}
          onMouseOut={mouseOut}
          display="flex"
          alignItems={"center"}
          paddingLeft={2}
        >
          <DragIndicatorIcon
            fontSize="small"
            sx={{
              position: "absolute",
              marginLeft: -2,
              alignSelf: "center",
              color: "text.secondary",
              display:
                isMouseOver && !(isOptionDisabled || disabled)
                  ? "flex"
                  : "none",
            }}
          />
          {subTypes.likert === type ? (
            <Box width={40}>
              <InputField
                autoFocus={`${option.id}number` === selectedId}
                placeholder={"❏"}
                type="label"
                inputValue={option.number}
                onChange={handleChange(option.id, "number")}
                disabled={isOptionDisabled || disabled}
              />
            </Box>
          ) : (
            <OptionIcon type={type} index={index} />
          )}

          <InputField
            autoFocus={`${option.id}title` === selectedId}
            placeholder={t("editor.placeholders.option")}
            inputValue={option.title}
            fullWidth
            type="label"
            onChange={handleChange(option.id, "title")}
            disabled={isOptionDisabled || disabled}
            onKeyDown={(e) => {
              if (e.code === "Enter" && allowOptionAdd)
                handleAddOptionAfterIndex(index);
            }}
          />
          <Tooltip title={t("common.buttons.remove")}>
            <IconButton
              aria-label="delete option"
              onClick={() => removeOption(option.id)}
              sx={{
                visibility:
                  isMouseOver && !(isOptionDisabled || disabled)
                    ? "visible"
                    : "hidden",
              }}
              disabled={disabled}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Draggable>
  );
}
